<template>
  <div>
    <div v-if="items.length">
      <div v-for="item in items" :key="item.id">
        <timeline-item :date="item.date">
          <div class="row w-100">
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Estatus:
              </label>
              <custom-balloon
                class="text-nowrap"
                :background-color="item.statusColor"
                :text="item.statusName"
                dot
              />
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Número de Solicitud:
              </label>
              <p>{{ item.requestCode | empty }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Fecha de Solicitud:
              </label>
              <p>{{ item.requestDate | date }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Realizado Por:
              </label>
              <p>{{ item.submittedBy | empty }}</p>
            </div>
          </div>
          <div class="row w-100">
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Fecha de Envío:
              </label>
              <p>{{ item.sendDate | date }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Asignado a:
              </label>
              <p>{{ item.assginedTo | empty }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Fecha de Transferencia:
              </label>
              <p>{{ item.transferDate | date }}</p>
            </div>
          </div>
          <div class="row w-100">
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Comentario:
              </label>
              <p>{{ item.comment | empty }}</p>
            </div>
          </div>
        </timeline-item>
      </div>
      <div class="row my-4">
        <div class="col text-center">
          <action-button
            v-if="hasMore"
            variant="outline-success custom-view-more actionButton"
            i="fas fa-chevron-down"
            @click="load"
          >
            Ver más
          </action-button>
        </div>
      </div>
    </div>
    <div v-else class="p-3">
      <custom-result-not-found text="No hay Información Disponible." />
    </div>
  </div>
</template>

<script>
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';
import CustomBalloon from 'custom-balloon';
import SectionTitle from 'SectionTitle';
import TimelineItem from '@quisit/timeline-item';

export default {
  name: 'InventoryMaterialsAndEquipmentsHistory',
  components: {
    TimelineItem,
    CustomResultNotFound,
    ActionButton,
    CustomBalloon,
    SectionTitle,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    page() {
      return this.data.page;
    },
    total() {
      return this.data.total;
    },
    items() {
      return this.data.items;
    },
    hasMore() {
      return this.total > this.items.length;
    },
  },
  methods: {
    load() {
      this.$emit('load', this.page + 1);
    },
  },
};
</script>

<style></style>
